// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1YL5y","logo":"styles_logo__1gos3"};